import {SET_ACTIONS_REMAINING} from 'constants/action-types.js';
import {SET_TIME_REMAINING} from 'constants/action-types.js';

var initialState = {
    actionsRemaining: 200,
    timeRemaining: 0,
};

const installationReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_ACTIONS_REMAINING:
        return {
            ... state,
            actionsRemaining: action.payload
        };
    case SET_TIME_REMAINING:
        return {
            ... state,
            timeRemaining: action.payload
        };
    default:
        return state;
    }
};

export default installationReducer;
